module.exports = __webpack_public_path__ + "static/media/landing.fa8ddeb1.jpeg";